import { StyleSheet } from 'react-native';
import Layout from '../../constants/Layout';

import {
  bold,
  editLinkColor,
  fontFamilyBold,
  fontSizeLarge,
  grey,
  fontSizeMedium,
  fontSizeSmall,
} from '../../constants/palette';

// FIXME: Use onLayOutEffect to fix this
const setWidth = Layout.isXtraSmallDevice ? '80%' : 'auto';

const styles = StyleSheet.create({
  bodyContainer: {
    width: setWidth,
  },
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
  },
  bottomSeparator: {
    height: 1,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  editLinkContainer: {
    justifyContent: 'flex-start',
  },
  editLinkText: {
    color: editLinkColor,
    fontWeight: bold,
    fontSize: fontSizeMedium,
  },
  genreButtons: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  genreText: {
    fontSize: fontSizeMedium,
  },
  genreSubText: {
    fontSize: fontSizeSmall,
    color: grey,
  },
  myGenresContainer: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 10,
    justifyContent: 'space-between',
  },
  title: {
    fontSize: fontSizeLarge,
    fontFamily: fontFamilyBold,
    margin: 10,
  },
  scrollViewContainer: {
    flex: 1,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
  errorContainer: {
    justifyContent: 'center',
    paddingTop: 20,
    alignItems: 'center',
  },
});

export default styles;
